<template>
  <div
    class="BoxMedico mb-4"
    :class="{'BoxMedico_error': verifyError()}">
    <div class="BoxMedico_header p-2">
      <h3 class="BoxMedico_header_title">
        {{ medico.nome }}
      </h3>
    </div>
    <div class="BoxMedico_body px-3 py-2">
      <div class="row no-gutters align-items-center justify-content-between">
        <div class="d-inline-flex BoxMedico_body_content">
          <div class="d-inline-block mr-5">
            <ul class="BoxMedico_list">
              <li class="BoxMedico_list_item BoxMedico_list_title">
                Medico Legista
              </li>

              <li class="BoxMedico_list_item">
                <strong>{{ medico.legista === 1 ? 'Sim' : 'Não' }}</strong>
              </li>
            </ul>
          </div>

          <div class="d-inline-block mr-5">
            <ul class="BoxMedico_list">
              <li class="BoxMedico_list_item BoxMedico_list_title">
                CRM
              </li>

              <li class="BoxMedico_list_item">
                <strong>{{ medico.crm }}</strong>
              </li>
            </ul>
          </div>
        </div>

        <div class="">
          <div v-if="!noEditButton"
               class="row no-gutters justify-content-end align-items-center">
            <div class="d-inline-block">
              <button
                type="button"
                class="btn btn-sm btn-danger mr-2"
                @click="$emit('remove', medico)">
                Remover
              </button>

              <button
                class="btn btn-sm btn-primary"
                type="button"
                @click="$emit('edit', medico)">
                Editar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BoxMedicos',
    props: {
      medico: { type: Object, default: ()=>{} },
      propIndex: {type: Number, default: -1},
      noEditButton: Boolean,
      propCorrecoes: {type: Object, default: () => ({})}
    },
    data () {
      return {
        errors_medico_one: false,
        errors_medico_two: false
      }
    },
    watch: {
      propCorrecoes () {
        this.verifyErrorsCarga()
      }
    },
    mounted () {
      this.verifyErrorsCarga()
    },
    methods: {
      verifyError () {
        if (this.propIndex == 0) {
          return this.errors_medico_one
        }

        if (this.propIndex == 1) {
          return this.errors_medico_two
        }
      },
      verifyErrorsCarga () {
        this.errors_medico_one = false
        this.errors_medico_two  = false

        Object.keys(this.propCorrecoes).forEach(key => {
          if (['NOME DO MÉDICO', 'ATESTANTE PRIMÁRIO'].indexOf(key) != -1) this.errors_medico_one = true

          if (['SEGUNDO MÉDICO', 'ATESTANTE SECUNDÁRIO'].indexOf(key) != -1) this.errors_medico_two = true
        })
      }
    }
  }
</script>

<style lang="scss">
  @import '../../../scss/_utilities/_exports';

  .BoxMedico {
    box-shadow: 0 0 pxToRem(4) 0 $color-dark;

    &_error {
      border: solid 2px #8B0000;
    }

    &_header {
      background-color: #01AEC9;
      color: $color-dark;

      &_title {
        font-size: pxToRem(14);
        font-weight: 500;
      }
    }

    &_body {
      &_content {}
    }

    &_list {
      font-size: pxToRem(14);
      list-style: none;
      margin: 0;
      padding: 0;

      &_item {}

      &_title {
        margin-bottom: pxToRem(4);
        text-decoration: underline;
      }
    }
  }
</style>
